module.exports = __webpack_public_path__ + "static/thpcsheep2-e1a93c5f545d573f11ea9c272983e3ad.jpeg";